// Geist is embedded in two weights only. Documents still set `italics: true` in places,
// and pdfmake throws when a style slot is undefined, so italics fall back to the uprights.
const GEIST = {
  normal: 'Geist-Regular.ttf',
  bold: 'Geist-Bold.ttf',
  italics: 'Geist-Regular.ttf',
  bolditalics: 'Geist-Bold.ttf'
};

let pdfMakePromise = null;

/**
 * Every PDF library is loaded on demand so no route chunk carries pdfmake, jsPDF,
 * pdf-lib or html2canvas until a user actually prints, downloads or faxes something.
 * pdfmake is configured once: our own Geist TTFs are the whole VFS, the
 * bundled Roboto VFS is not loaded because no document references it.
 */
export const loadPdfMake = () => {
  if (!pdfMakePromise) {
    pdfMakePromise = Promise.all([
      import('pdfmake/build/pdfmake'),
      import('./fonts/fontBase64')
    ]).then(([mod, { fontBase64 }]) => {
      const pdfMake = mod.default ?? mod;
      pdfMake.vfs = { ...fontBase64 };
      pdfMake.fonts = { Geist: GEIST };
      return pdfMake;
    });
    pdfMakePromise.catch(() => {
      pdfMakePromise = null;
    });
  }
  return pdfMakePromise;
};

export const loadJsPdf = async () => {
  const [{ jsPDF }, { default: autoTable }] = await Promise.all([
    import('jspdf'),
    import('jspdf-autotable')
  ]);
  return { jsPDF, autoTable };
};

export const loadPdfLib = () => import('pdf-lib');

export const loadFontkit = async () => (await import('@pdf-lib/fontkit')).default;

export const loadHtml2Canvas = async () => (await import('html2canvas')).default;
